/**
 * Os links dos e-mails (docs/spec/email.md): o da confirmação e o da troca do e-mail
 * (`?confirm-email=<código>`) e o da recuperação da senha (`?reset-password=<código>`). A página lê o
 * código uma vez e o tira do endereço, para ele não ficar no histórico nem num favorito.
 */
import { EMAIL_CONFIRMATION_PARAM, PASSWORD_RESET_PARAM } from '../shared.js';

/** O código do parâmetro `param` em `search` (null sem ele) e o resto da busca, sem o código. */
export function linkCodeOf(search: string, param: string): { code: string | null; rest: string } {
  const params = new URLSearchParams(search);
  const code = params.get(param)?.trim() || null;
  params.delete(param);
  const rest = params.toString();
  return { code, rest: rest ? `?${rest}` : '' };
}

/** O código do link da confirmação em `search`, e o resto da busca. */
export function emailLinkOf(search: string): { code: string | null; rest: string } {
  return linkCodeOf(search, EMAIL_CONFIRMATION_PARAM);
}

/** Tira o código de `param` do endereço da página e o devolve; null quando a página não veio do link. */
function takeLinkCode(param: string): string | null {
  if (!new URLSearchParams(window.location.search).has(param)) return null;
  const { code, rest } = linkCodeOf(window.location.search, param);
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest}${window.location.hash}`);
  return code;
}

/** O link da confirmação (ou da troca do e-mail). */
export function takeEmailLink(): string | null {
  return takeLinkCode(EMAIL_CONFIRMATION_PARAM);
}

/** O link da recuperação da senha. */
export function takeResetLink(): string | null {
  return takeLinkCode(PASSWORD_RESET_PARAM);
}
